import * as React from "react";
import {Conductor} from "@models/conductor";
import {Button, Card, Col, Icon} from "antd";
import {FormattedMessage} from "react-intl";
import SearchPaymentsComponent from "@components/reports/Search";
import {NavLink} from "react-router-dom";
import whitListData from "@hocs/withListData";
import supplierApi from "@api/supplier";
import withPaginationComponent from "@hocs/withPaginationComponent";
import SuppliersPaymentsTable from "@components/reports/SuppliersPaymentsTable";
import {getFormattedPrice} from "@utils";
import {Row} from 'antd';
import {useState} from "react";
import {BASE_URL} from "../../api/httpRequest";
import {useSelector} from "react-redux";


interface PropsFromHoc {
  data          :Conductor[];
  isFetched     : boolean;
  currentPage   : number;
  search        : (params: object | null) => void;
  onDeleteItem  : (id:string) => void;
}

type AllProps = PropsFromHoc ;

const SuppliersPaymentsPage: React.FC<AllProps> = (props) => {
  const {data, isFetched, currentPage, search} = props;
  const [downloadUrl, setDownloadUrl] = useState(null)
  const {payments, total_credit=0, total_credit_in_period=0, total_debit=0,total_debit_in_period=0} = data;
  const access_token = useSelector(state => state.auth.access_token);
  
  const deleteConductor = (item: Conductor): any => {
    const {onDeleteItem} = props;
    supplierApi.delete({
        params: {
          channel_id: item.channel.id,
          conductor_id : item.id
        }
      })
      .then(() => {
        onDeleteItem(item.id)
      })
      .catch(error => console.log(error))
  };
  
  const applySearch = (params) => {
    search(params)
    if (params.supplier_id) {
      const {supplier_id, ...rest} = params
      const url = `${BASE_URL}/suppliers/${supplier_id}/stats/_report?${new URLSearchParams({...rest, access_token}).toString()}`;
      setDownloadUrl(url)
    }
    else {
    
    }
  };
  
  return (
    <div>
      <div className={`toggle-button-wrapper`}>
        <NavLink to={`/suppliers/payments/create`}>
          <Button type={"primary"}>
            <FormattedMessage
              id="app.new_payment"
              defaultMessage={`New Payment`}
            />
          </Button>
        </NavLink>
      </div>
      <div className={"page-table-wrapper"}>
        
        <Card className={`page-table-header`} bordered={false}>
          <SearchPaymentsComponent search={applySearch}/>
        </Card>
        
        <Card>
          <Row className={'report'}>
            <Col span={10}>
              <div>
                <FormattedMessage
                  id="app.total_credit"
                  defaultMessage={`Total credit`}
                />
                {`: `} {getFormattedPrice(total_credit)}
              </div>
      
              <div>
                <FormattedMessage
                  id="app.total_credit_in_period"
                  defaultMessage={`total credit in period`}
                />
                {`: `} {getFormattedPrice(total_credit_in_period)}
              </div>
    
            </Col>
            <Col span={10}>
              <div>
                <FormattedMessage
                  id="app.total_debit"
                  defaultMessage={`Total debit`}
                />
                {`: `} {getFormattedPrice(total_debit)}
              </div>
      
              <div>
                <FormattedMessage
                  id="app.total_debit_in_period"
                  defaultMessage={`total debit in period`}
                />
                {`: `} {getFormattedPrice(total_debit_in_period)}
              </div>
            </Col>
    
            {!!downloadUrl && !!total_credit && (
              <Col span={4} className={'download-btn-wrapper'}>
                <a href={downloadUrl}>
                  <Button type={"primary"}>
                    <Icon type="file-excel"/>
                    <FormattedMessage
                      id="app.download_excel_file"
                      defaultMessage={`Download Excel File`}
                    />
                  </Button>
                </a>
              </Col>
            )}
          </Row>
        </Card>
        
        <SuppliersPaymentsTable
          data={payments}
          currentPage={currentPage}
          rowKey={record => record.id}
          deleteFn={deleteConductor}
          loading={false}
        />
      </div>
    </div>
  );
};

export default whitListData(
  withPaginationComponent(SuppliersPaymentsPage),
  {
    fetchRequest : supplierApi.fetchPayments,
    paginationOnScroll: false,
    initialFetch : false
  }
);
